<template>
    <v-dialog class="content-dialog" v-model="leadDialog" persistent :fullscreen="mobile">
        <div v-if="!lead && loading" class="dialog-loading-container">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-card rounded="lg">
            <LeadDialogHeader :leads="lead" v-if="lead" @close="closeDialog" />
            <v-divider></v-divider>
            <div  class="content-dialog-card">
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="content-dialog-data-wrapper">
                            <LeadDialogRawData :leads="lead" v-if="lead" />
                            <v-divider></v-divider>
                            <LeadDialogData :leads="lead" v-if="lead" />
                            <LeadDialogUploads v-if="uploads" />
                            <LeadDialogWhatsAppMessages v-if="whatsAppMessages" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="content-dialog-data-wrapper">
                            <LeadFunnelData :leads="lead" v-if="lead" />
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useDisplay } from 'vuetify'
import LeadDialogHeader from './LeadDialogHeader.vue';
import LeadDialogData from './LeadDialogData.vue';
import LeadDialogRawData from './LeadDialogRawData.vue';
import LeadFunnelData from './LeadFunnelData.vue';
import LeadDialogUploads from './LeadDialogUploads.vue';
import LeadDialogWhatsAppMessages from './LeadDialogWhatsAppMessages.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        LeadDialogHeader,
        LeadDialogData,
        LeadDialogRawData,
        LeadFunnelData,
        LeadDialogUploads,
        LeadDialogWhatsAppMessages
    },
    props: {
        leadId: {
            type: String,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    data() {
        return {

        }
    },
    watch: {
        leadId: {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.fetchLeadData(newId);
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('lead', ['loading', 'lead', 'leadDialog', 'uploads', 'whatsAppMessages']),
    },
    methods: {
        ...mapActions('lead', ['fetchLeadData', 'closeLeadDialog', 'setLeadDialog', 'resetLead']),
        closeDialog() {
            this.$store.dispatch('lead/closeLeadDialog');
        },
    },
    beforeUnmount() {
        this.resetLead();
    }

}
</script>

<style lang="scss" scoped></style>